import { FC, ReactElement, ReactNode } from 'react'

import { composeClasses } from '@/utils/compose-classes'
import { Flex } from '../flex'
import { AsType } from '../as'

export type IconDefaultProps = 'account' | 'notification' | 'chat'

export type TSubscription =
  | {
      plan: 'basic'
      onClick: () => void
    }
  | {
      plan: 'premium'
      daysLeft: number
      onClick?: () => void
    }
export interface BaseNavbarProps {
  title?: string
  as?: AsType
  children?: ReactNode
  className?: string
  subscription?: TSubscription
  interactionIcons?: {
    icon: IconDefaultProps | ReactElement | Iterable<ReactNode>
    onClick: () => void
    hideOnMobile?: boolean
    className?: string
  }[]
}

export type OmittedNavbarProps = Omit<
  BaseNavbarProps,
  'title' | 'interactionIcons' | 'subscription'
>

export const Navbar: FC<OmittedNavbarProps> = ({
  children,
  className,
  as = 'nav'
}) => {
  return (
    <Flex
      justify="between"
      as={as}
      className={composeClasses(
        'p-2 px-6 border-b border-surface-strokes',
        className
      )}
    >
      {children}
    </Flex>
  )
}

export default Navbar
